import { render, staticRenderFns } from "./purchaseReturnedProductRecords.vue?vue&type=template&id=41751f3d&scoped=true"
import script from "./purchaseReturnedProductRecords.vue?vue&type=script&lang=js"
export * from "./purchaseReturnedProductRecords.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnedProductRecords.vue?vue&type=style&index=0&id=41751f3d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41751f3d",
  null
  
)

export default component.exports